const initialValues = {
  type: "email",
  document: "",
  password: "",
};

export default initialValues;
